import { defineComponent as d, computed as a, openBlock as s, createElementBlock as c, createElementVNode as t, toDisplayString as h, createCommentVNode as n, normalizeStyle as p, createStaticVNode as f } from "vue";
const m = ["viewBox"], _ = /* @__PURE__ */ t("mask", { id: "a3a38d10-e2fb-486a-85dd-84427101a446" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), z = { mask: "url(#a3a38d10-e2fb-486a-85dd-84427101a446)" }, k = { key: 0 }, u = /* @__PURE__ */ f('<path fill="#0052b4" d="M0 0h512v512H0z"></path><path fill="#eee" d="M302.7 233.7a103.1 103.1 0 0 0 0 206 103.1 103.1 0 0 0 0-206zm0 20c46 0 83 37 83 83s-37 83-83 83-83-37-83-83 37-83 83-83z"></path><path fill="#eee" d="M209.4 72.3a103.1 103.1 0 0 0 0 206 103.1 103.1 0 0 0 0-206zm0 20c46 0 83 37 83 83s-37 83-83 83-83-37-83-83 37-83 83-83z"></path><path fill="#eee" d="M302.7 72.3a103.1 103.1 0 0 0 0 206 103.1 103.1 0 0 0 0-206zm0 20c46 0 83 37 83 83s-37 83-83 83-83-37-83-83 37-83 83-83z"></path><path fill="#eee" d="M349.2 153a103.1 103.1 0 0 0 0 206 103.1 103.1 0 0 0 0-206zm0 20c46 0 83 37 83 83s-37 83-83 83-83-37-83-83 37-83 83-83z"></path><path fill="#eee" d="M209.4 233.7a103.1 103.1 0 0 0 0 206 103.1 103.1 0 0 0 0-206zm0 20c46 0 83 37 83 83s-37 83-83 83-83-37-83-83 37-83 83-83z"></path><path fill="#eee" d="M162.8 153a103.1 103.1 0 0 0 0 206 103.1 103.1 0 0 0 0-206zm0 20c46 0 83 37 83 83s-37 83-83 83-83-37-83-83 37-83 83-83z"></path><path fill="#eee" d="M256 153.1a103.1 103.1 0 0 0 0 206 103.1 103.1 0 0 0 0-206zm0 20c46 0 83 37 83 83 0 45.9-37 83-83 83s-83-37.1-83-83c0-46 37-83 83-83z"></path>', 8), g = { fill: "none" }, v = ["r"], y = /* @__PURE__ */ d({
  __name: "earth",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = a(() => 512 + 2 * e.strokeWidth), o = a(() => -e.strokeWidth), r = a(() => 256 + e.strokeWidth / 2);
    return (x, M) => (s(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${o.value} ${o.value} ${l.value} ${l.value}`
    }, [
      _,
      t("g", z, [
        e.flagName ? (s(), c("title", k, h(e.flagName), 1)) : n("", !0),
        u
      ]),
      t("g", g, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: r.value,
          fill: "none",
          style: p({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, v)
      ])
    ], 8, m));
  }
});
export {
  y as default
};
//# sourceMappingURL=earth-c02b5653.js.map
